import { useState } from 'react';
import { registerUser } from './api';

const USERNAME_RE = /^[a-z_-]{3,32}$/;

function validateUsername(username) {
  if (!username) return 'username is required';
  if (!USERNAME_RE.test(username)) {
    return 'username must be 3-32 characters, lowercase letters (a-z), hyphens (-), and underscores (_) only';
  }
  return null;
}

function validatePassword(password) {
  if (!password) return 'password is required';
  if (password.length < 8) return 'password must be at least 8 characters';
  if (password.length > 256) return 'password must be at most 256 characters';
  return null;
}

export default function RegisterForm({ onCancel }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [fieldErrors, setFieldErrors] = useState({});
  const [status, setStatus] = useState('idle'); // idle | submitting | success | error
  const [message, setMessage] = useState('');
  const [createdUsername, setCreatedUsername] = useState('');

  async function handleSubmit(event) {
    event.preventDefault();

    const usernameError = validateUsername(username);
    const passwordError = validatePassword(password);
    const confirmError = password !== confirmPassword ? 'passwords do not match' : null;

    if (usernameError || passwordError || confirmError) {
      setFieldErrors({ username: usernameError, password: passwordError, confirm: confirmError });
      return;
    }

    setFieldErrors({});
    setStatus('submitting');
    setMessage('');

    try {
      const result = await registerUser(username, password);
      setCreatedUsername(result.username ?? username);
      setStatus('success');
    } catch (err) {
      setStatus('error');
      setMessage(err.message || 'Registration failed. Please try again.');
    }
  }

  if (status === 'success') {
    return (
      <div className="terminal-box">
        <p className="success-line">
          [ ACCOUNT CREATED ] user &quot;{createdUsername}&quot; has joined the burnination.
        </p>
        <p className="dim-line">you can sign in now with LOGIN.</p>
        <button type="button" className="retro-button" onClick={onCancel}>
          BACK TO LAIR
        </button>
      </div>
    );
  }

  return (
    <form className="terminal-box" onSubmit={handleSubmit}>
      <p className="form-title">== NEW ACCOUNT REGISTRATION ==</p>

      <label className="form-row" htmlFor="username">
        <span>USERNAME:</span>
        <input
          id="username"
          name="username"
          type="text"
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value.toLowerCase())}
          disabled={status === 'submitting'}
          spellCheck="false"
        />
      </label>
      {fieldErrors.username && <p className="error-line">! {fieldErrors.username}</p>}

      <label className="form-row" htmlFor="password">
        <span>PASSWORD:</span>
        <input
          id="password"
          name="password"
          type="password"
          autoComplete="new-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          disabled={status === 'submitting'}
        />
      </label>
      {fieldErrors.password && <p className="error-line">! {fieldErrors.password}</p>}

      <label className="form-row" htmlFor="confirmPassword">
        <span>CONFIRM:</span>
        <input
          id="confirmPassword"
          name="confirmPassword"
          type="password"
          autoComplete="new-password"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          disabled={status === 'submitting'}
        />
      </label>
      {fieldErrors.confirm && <p className="error-line">! {fieldErrors.confirm}</p>}

      {status === 'error' && <p className="error-line">! {message}</p>}

      <div className="button-row">
        <button type="submit" className="retro-button" disabled={status === 'submitting'}>
          {status === 'submitting' ? 'BURNINATING...' : 'CREATE ACCOUNT'}
        </button>
        <button
          type="button"
          className="retro-button retro-button--ghost"
          onClick={onCancel}
          disabled={status === 'submitting'}
        >
          CANCEL
        </button>
      </div>
    </form>
  );
}
